<script>
  import { AppState } from '../../etc/stores';
  import flagKeys from '../../etc/flagKeys';

  const { primary200, primary600 } = $AppState.theme.colors;
</script>

<svg
  width="32"
  height="32"
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <rect width="32" height="32" rx="8" fill={primary600} />
  {#if $AppState.featureFlags.includes(flagKeys.NEW_COIN_ICON)}
    <path
      d="M8 11.0249V16.394C8 18.6182 11.5813 20.4209 16 20.4209C20.4187 20.4209 24 18.6182 24 16.394V11.0249"
      stroke={primary200}
      stroke-width="1.5"
    />
    <path
      d="M8 16.3939V21.7631C8 23.9872 11.5813 25.7899 16 25.7899C20.4187 25.7899 24 23.9872 24 21.7631V16.3939"
      stroke={primary200}
      stroke-width="1.5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 15.0537C20.4183 15.0537 24 13.2508 24 11.0268C24 8.80288 20.4183 7 16 7C11.5817 7 8 8.80288 8 11.0268C8 13.2508 11.5817 15.0537 16 15.0537Z"
      stroke={primary200}
      stroke-width="1.5"
      stroke-linecap="square"
    />
  {:else}
    <path
      d="M16.0002 10.4444L17.5716 14.4286L21.5558 15.9999L17.5716 17.5713L16.0002 21.5555L14.4289 17.5713L10.4447 15.9999L14.4289 14.4286L16.0002 10.4444Z"
      fill={primary200}
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 24.5C20.6944 24.5 24.5 20.6944 24.5 16C24.5 11.3056 20.6944 7.5 16 7.5C11.3056 7.5 7.5 11.3056 7.5 16C7.5 20.6944 11.3056 24.5 16 24.5ZM16 26C21.5228 26 26 21.5228 26 16C26 10.4772 21.5228 6 16 6C10.4772 6 6 10.4772 6 16C6 21.5228 10.4772 26 16 26Z"
      fill={primary200}
    />
  {/if}
</svg>
